<template>
	<div>
		<b-overlay :show="loading" no-wrap rounded></b-overlay>
		<b-table small stacked="sm" striped hover :fields="modelColumns" :items="items" :show-empty="true" :empty-text="this.$t('payments.noPayment')">
			<template #cell(total)="row">
				{{ $root.formatLblPrice(row.item.total, payment.currency) }}
			</template>
			<template #cell(engineTotal)="row">
				{{ $root.formatLblPrice(row.item.engineTotal, row.item.engineCurrency) }}
			</template>
		</b-table>
	</div>
</template>

<script>
export default {
	props: {
		payment: {
			type: Object,
			required: true,
		}
	},
	data() {
		return {
			data: [],
			loading: false,
			modelColumns: [
				{key: 'reference', label: this.$t('payments.reference')},
				{key: 'cardholder', label: this.$t('payments.cardHolder')},
				{key: 'cardType', label: this.$t('payments.cardType')},
				{key: 'last4', label: this.$t('payments.last4')},
				{key: 'engineTotal', label: this.$t('payments.totalEngine'), class: 'text-right'},
				{key: 'total', label: this.$t('payments.total'), class: 'text-right'},
				{key: 'creationDatetime', label: this.$t('payments.date')},
				{key: 'status', label: this.$t('payments.status')},
			],
		}
	},
	methods: {},
	mounted: function () {

	},
	computed: {
		items() {
			return this.payment.transactions ?? []
		}

	},

}
</script>
